import { useQuery } from "@tanstack/react-query";

import { supportRequestService } from "@/app/services/supportRequestService";
import { SupportRequestCountsResponse } from "@/app/services/supportRequestService/getSupportRequestCounts";

export const SUPPORT_REQUEST_COUNTS_QUERY_KEY = "supportRequestCounts";

const EMPTY_COUNTS: SupportRequestCountsResponse = {
  open: 0,
  claimable: 0,
  mine: 0,
  inProgress: 0,
  all: 0,
  team: 0,
};

interface UseSupportRequestCountsParams {
  enabled?: boolean;
  poll?: boolean;
}

export const useSupportRequestCounts = ({
  enabled = true,
  poll = false,
}: UseSupportRequestCountsParams = {}) => {
  const { data } = useQuery({
    queryKey: [SUPPORT_REQUEST_COUNTS_QUERY_KEY],
    queryFn: supportRequestService.getSupportRequestCounts,
    enabled,
    staleTime: 30_000,
    ...(poll && {
      refetchInterval: 60_000,
      refetchIntervalInBackground: true,
    }),
  });

  return data ?? EMPTY_COUNTS;
};
